import { create } from 'zustand';

const initialState = {
    data: [],
    total: 0,
    totalToday: 0,
    totalNext: 0,
    title: ''
};

export const useAvailableLinesStore = create((set) => ({

    ...initialState,

    setAvailableLines: ({
        data,
        total,
        totalToday,
        totalNext,
        title
    }) => {

        set({
            data,
            total,
            totalToday,
            totalNext,
            title
        });

    },

    clearAvailableLines: () => {
        set(initialState);
    }

}));